import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QualityIBMComponent } from './quality.component';
import { FormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';



@NgModule({
  declarations: [
    QualityIBMComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule
  ], exports:[
    QualityIBMComponent
  ]
})
export class QualityIBMModule { }
